<nav id="header" class="navbar navbar-expand-lg navbar-dark bg-dark header-bg fixed-top py-0">
  <a class="logo" [routerLink]="['discovery']">

  </a>
  <ul class="navbar-nav mr-auto" id="navbar-left">
    <li *ngFor="let entry of menuEntries" class="nav-item mr-1">
      <a class="nav-link" [routerLink]="[entry.instanceType]" [routerLinkActive]="['active']">
        <ng-container *ngIf="entry.icon.indexOf('.png')>=0">
          <img src="{{entry.icon}}" class="nav_icon"/>
        </ng-container>
        <ng-container *ngIf="entry.icon.indexOf('.png')<0">
          <i class="mio vam">{{entry.icon}}</i>
        </ng-container>
        {{entry.title}}
      </a>
    </li>

    <li class="debug-mode-items nav-item mr-1">
      <a class="nav-link" [routerLink]="['debugmode']" [routerLinkActive]="['active']">
        <i class="mio vam">memory</i> Debug
      </a>
    </li>
  </ul>
  <ul id="navbar-right" class="navbar-nav ml-auto">


    <!--
    <li id="active-searches-button" class="nav-item noarrow" ngbDropdown display="dynamic" placement="bottom-right"
      container="body">
      <a class="nav-link " ngbDropdownToggle>
        <i class="vam mio">search</i>
        <span *ngIf="activeSearches.size == 0" class="badge badge-pill badge-light">{{activeSearches.size | number}}
        </span>
        <span *ngIf="activeSearches.size > 0" class="badge badge-pill badge-light text-white"
          [ngStyle]="{'background-color':searchPoolStatusColor}">{{activeSearches.size | number}}
        </span>
      </a>
      <div class="searchPoolPopover pt-0" ngbDropdownMenu>
        <div class="dropdown-header py-1 px-3">Active searches</div>
        <div class="p-2">
          <ng-container *ngIf="activeSearchesDetails.size == 0">
            <div class="text-center">
              <p class="text-muted"><i class="vam mio mr-1">search</i> There are no active searches</p>
            </div>
          </ng-container>
          <ng-container *ngIf="activeSearchesDetails.size >= 0">
            <div *ngFor="let asd of activeSearchesDetails | keyvalue" class="mb-1">
              <span class="float-right">
                <a *ngIf="!asd.value.canceled" (click)="killActiveSearch(asd.key)"
                  class="btn btn-danger btn-sm py-0 px-1 text-white"><i class="mio text-white">stop</i></a>
                <a *ngIf="asd.value.canceled" class="btn text-muted btn-sm py-0 px-1"><i
                    class="mio text-muted">stop</i></a>
              </span>
              <span class="mb-2">{{asd.value.widgetName}}<br>
                <small>
                  <strong>Submitted:</strong>{{asd.value.startTime | date: user.options['dateFormat'] : user.options['timeZone'] != 'Client default' ? user.options['timeZone'] : '' }}
                  <strong class="ml-3">Duration: </strong> {{asd.value.duration | number}} sec
                </small>
              </span>
              <ngb-progressbar [value]="asd.value.executionPercentage" [type]="'warning'" [height]="'1px'">
              </ngb-progressbar>
            </div>
          </ng-container>
        </div>
      </div>
    </li>
  -->

    <li class="nav-item noarrow cluster-status-indicator" id="search-pool-button" ngbDropdown display="dynamic"
      placement="bottom-right" container="body">
      <a class="nav-link py-0 px-2 cluster-status-link" ngbDropdownToggle
        [ngbTooltip]="clusterStatusTooltip" tooltipClass="header-status-tooltip" container="body" placement="bottom">
        <span class="cluster-status-dot" [ngClass]="'cluster-status-' + clusterStatusLevel"
          [style.background-color]="searchPoolStatusColor"></span>
        <small class="cluster-status-label" *ngIf="clusterNodeCount > 0">
          {{ clusterTotalActive }}/{{ clusterTotalThreads }}
          <span class="cluster-queue" *ngIf="clusterTotalQueue > 0">+{{ clusterTotalQueue }}</span>
        </small>
        <small class="cluster-status-label cluster-status-loading" *ngIf="clusterNodeCount === 0">…</small>
      </a>
      <div class="header-status-popover pt-0" ngbDropdownMenu>
        <div class="dropdown-header py-2 pb-1 px-3">Cluster status</div>
        <div class="p-2 pt-2">
          <ng-container *ngIf="!searchPoolList || searchPoolList.length == 0">
            <p class="text-muted text-small my-2 py-0 mb-0">
              <i class="fa fa-circle-o-notch fa-spin"></i> Loading cluster status...
            </p>
          </ng-container>
          <ng-container *ngIf="searchPoolList && searchPoolList.length > 0">
            <p class="mb-2">
              <strong>{{ clusterTotalActive }}</strong>
              <span class="text-muted"> / {{ clusterTotalThreads }} active threads</span>
            </p>
            <ngb-progressbar [value]="searchPoolPercentage" [type]="clusterFillBarType" height="6px" class="mb-3"></ngb-progressbar>
            <ul class="list-unstyled mb-0 small text-muted">
              <li class="d-flex justify-content-between mb-1">
                <span>Status</span>
                <strong class="text-dark">{{ clusterStatusLabel }}</strong>
              </li>
              <li class="d-flex justify-content-between mb-1">
                <span>Nodes</span>
                <strong class="text-dark">{{ clusterNodeCount }}</strong>
              </li>
              <li class="d-flex justify-content-between mb-1">
                <span>Queued</span>
                <strong class="text-dark">{{ clusterTotalQueue }}</strong>
              </li>
             
            </ul>
            <hr />
            <p class="text-muted mb-2 mt-3 small" *ngIf="clusterNodeCount > 1">Nodes list</p>
            <ul class="list-unstyled mb-0 small text-muted" *ngIf="clusterNodeCount > 1">
              <li class="d-flex justify-content-between mb-1" *ngFor="let sp of searchPoolList">
                <span class="text-truncate pr-2">{{ sp.host }}</span>
                <strong class="text-dark text-nowrap">
                  {{ sp.active }}/{{ sp.threads }}
                  <span class="cluster-queue" *ngIf="sp.queue > 0">+{{ sp.queue }}</span>
                </strong>
              </li>
            </ul>
            <p class="text-muted mb-0 mt-3 small">
              Search thread pool usage across Algorilla data nodes.
            </p>
            <p class="text-muted mb-0 mt-2 small text-right header-status-updated" *ngIf="clusterLastUpdated">
              Last updated
              {{ clusterLastUpdated | date: user.options['dateFormat'] : user.options['timeZone'] != 'Client default' ? user.options['timeZone'] : '' }}
            </p>
          </ng-container>
        </div>
      </div>
    </li>

    <li class="nav-item noarrow rate-limit-indicator" *ngIf="rateLimitEnabled" ngbDropdown display="dynamic"
      placement="bottom-right" container="body">
      <a class="nav-link py-0 px-2 rate-limit-link" ngbDropdownToggle
        [ngbTooltip]="tokenStatusTooltip" tooltipClass="header-status-tooltip" container="body" placement="bottom">
        <span class="rate-limit-dot" [ngClass]="'rate-limit-' + tokenStatusLevel"
          [style.background-color]="tokenStatusColor"></span>
        <small class="rate-limit-label">{{ projectedTokens }}/{{ tokenMaxBurst }}</small>
      </a>
      <div class="header-status-popover pt-0" ngbDropdownMenu>
        <div class="dropdown-header py-2 pb-1 px-3">Query tokens</div>
        <div class="p-3 pt-2">
          <p class="mb-2">
            <strong>{{ projectedTokens }}</strong>
            <span class="text-muted"> / {{ tokenMaxBurst }} effective</span>
          </p>
          <ngb-progressbar [value]="tokenFillPercent" [type]="tokenFillBarType" height="6px" class="mb-3"></ngb-progressbar>
          <ul class="list-unstyled mb-0 small text-muted">
            <li class="d-flex justify-content-between mb-1">
              <span>Stored balance</span>
              <strong class="text-dark">{{ storedTokens }}</strong>
            </li>
            <li class="d-flex justify-content-between mb-1">
              <span>Refill rate</span>
              <strong class="text-dark">{{ tokenRefillRate }}/s</strong>
            </li>
            <li class="d-flex justify-content-between" *ngIf="secondsToFullBucket !== null && secondsToFullBucket > 0">
              <span>Time to full bucket</span>
              <strong class="text-dark">~{{ secondsToFullBucket }}s</strong>
            </li>
            <li class="d-flex justify-content-between" *ngIf="secondsToFullBucket === 0">
              <span>Bucket</span>
              <strong class="text-dark">Full</strong>
            </li>
          </ul>
          <p class="text-muted mb-0 mt-3 small">
            Heavy queries (wide time ranges, aggregations, many widgets) consume more tokens.
          </p>
        </div>
      </div>
    </li>

    <!--
<div style="background:#fff;width:200px; height:50px;" id="pageHeader"></div>
    -->
    <li class="nav-item" id="user-info-button" ngbDropdown display="dynamic" placement="bottom-right" container="body">
      <a class="nav-link" ngbDropdownToggle>
        <i class="mio">person_pin</i> {{user.displayName != null ? user.displayName : user.name}}
      </a>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="user-options pt-0">
        <div class="dropdown-header py-2 pb-1 px-3"> User info </div>
        <div class="px-3 py-3">
          <ul class="list-group">
            <li class="list-group-item"><strong>Username: </strong> {{user.name}}</li>
            <li class="list-group-item"><strong>Display name: </strong> {{user.displayName}}</li>
            <li class="list-group-item"><strong>Groups: </strong> <span
                *ngFor="let group of user.groups | objNgFor; let i = index; ">{{user.groups[group]}}
                <ng-container *ngIf="i+1 < countObjectKeys(user.groups)">, </ng-container>
              </span></li>
            <li class="list-group-item"><strong>Searchable types: </strong>
              <ng-container *ngIf="user.typesWhiteList.length > 0"><span
                  *ngFor="let st of user.typesWhiteList; let i = index;">{{st}}
                  <ng-container *ngIf="i+1 < user.typesWhiteList.length">, </ng-container> </span></ng-container>
              <ng-container *ngIf="user.typesWhiteList.length == 0">no type specified</ng-container>
            </li>
            <li class="list-group-item"><strong>Capabilities: </strong>
              <span class="mr-1" *ngIf="user.admin">Administrator</span>
              <span class="mr-1" *ngIf="user.modeler">Event Modeler</span>
              <span class="mr-1" *ngIf="user.persistence">Manage Persistence</span>
            </li>
          </ul>
        </div>
        <div class="dropdown-divider"></div>
        <button ngbDropdownItem (click)="openModal()"><i class="mio vam mr-1">settings_applications</i>Settings</button>
        <button *ngIf="!debugMode" ngbDropdownItem (click)="enableDebugMode()"><i class="mio vam mr-1">memory</i>Enable
          debug mode</button>
        <button *ngIf="debugMode" ngbDropdownItem (click)="enableDebugMode()"><i class="mio vam mr-1">memory</i>Disable
          debug mode</button>
        <div class="dropdown-divider"></div>
        <button ngbDropdownItem (click)="logout()"> <i class="mio vam mr-1">exit_to_app</i> Logout</button>
      </div>
    </li>
  </ul>
</nav>

<app-modal #userOptionsModal modalTitle="User settings" [width]="700" [minHeight]="300" [minimizable]="false"
  (closeEvent)="displayUserSettings = false" [customCloseEvent]="true" [zIndex]="1100" [scrollTop]="true"
  [backdrop]="true" [maximizable]="false" *ngIf="displayUserSettings">
  <ng-container class="app-modal-body">
    <form>
      <div class="form-group">
        <label for="dateFormats">Date format</label>
        <ng-select [items]="userDateFormats" [multiple]="false" [closeOnSelect]="true" bindValue="format"
          appendTo="body" placeholder="Select a date format" name="dateFormats"
          [(ngModel)]="userSettings['selectedDateFormat']">
          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
            {{item.format}} - {{item.example}}
          </ng-template>
          <ng-template ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
            {{item.format}}
          </ng-template>
        </ng-select>

      </div>
      <div class="form-group">
        <label for="timeZones">Timezone</label>
        <ng-select [items]="userTimezones" [multiple]="false" [closeOnSelect]="true" placeholder="Select a timezone"
          appendTo="body" name="timeZones" [(ngModel)]="userSettings['timeZone']">
        </ng-select>
      </div>
      <div class="form-group">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" name="showTimezone"
            [checked]="userSettings['showTimezone']" id="showTimezone" [(ngModel)]="userSettings['showTimezone']">
          <label class="custom-control-label pointer" for="showTimezone">Show Timezone</label>
        </div>        
      </div>
    </form>
  </ng-container>
  <ng-container class="app-modal-footer">
    <div class="d-lg-flex justify-content-between flex-grow-1">
      <button type="button" class="btn btn-light btn-sm" (click)="displayUserSettings = false">Cancel</button>
      <button type="button" class="btn btn-primary btn-sm" (click)="saveUserSettings()">Save</button>
    </div>
  </ng-container>

</app-modal>